let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jJ1k5")).then(() => parcelRequire('9rNlY'));